import { DateRange } from "../hooks/useDateRangeFilter";

interface DataPoint {
    month: [string, string]; // [year, month]
    [key: string]: any;
}

function dataToDateString([year, month]: [string, string]): string {
    const monthMap: Record<string, string> = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
    };
    return `${year}-${monthMap[month]}`;
}

export function filterDataByDateRange<T extends DataPoint>(
    data: T[],
    dateRange: DateRange,
): T[] {
    if (!dateRange.startDate || !dateRange.endDate) {
        return data;
    }

    return data.filter((item) => {
        const itemDate = dataToDateString(item.month);
        return itemDate >= dateRange.startDate && itemDate <= dateRange.endDate;
    });
}

export function getAvailableDates<T extends DataPoint>(data: T[]): string[] {
    return data
        .map((item) => dataToDateString(item.month))
        .sort()
        .filter((date, index, arr) => arr.indexOf(date) === index);
}
